import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { Settings } from 'src/app/component/user profile/edit-user-profile/edit-user-profile.component';
import { DispatchCenterService } from 'src/app/service/dispatch-center-service/dispatch-center-service';

@Component({
  selector: 'app-notifications-slideout',
  templateUrl: './notifications-slideout.component.html',
  styleUrls: ['./notifications-slideout.component.css']
})
export class NotificationsSlideoutComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<any>();
  notifications = [];
  dateFormat = '';
  timeFormat = '';

  constructor(
    private dispatchCenterService: DispatchCenterService
  ) { }

  ngOnInit() {
    this.getNotifications();
    this.getFormats();
  }

  getFormats() {
    const dateFormat = localStorage.getItem(Settings.DATE_FORMAT);
    const timeFormat = localStorage.getItem(Settings.TIME_FORMAT);
    this.dateFormat = dateFormat ? dateFormat : Settings.DEFAULT_DATE_FORMAT;
    this.timeFormat = timeFormat ? timeFormat : Settings.DEFAULT_TIME_FORMAT
  }

  getNotifications() {
    this.dispatchCenterService
      .getNotifications()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.notifications = data;
        }
      });
  }

  ngOnDestroy(): void {
  }
}
